// Generated by scripts/copy-vendor.js at build time. Do not edit.
export const VENDOR = {
  tf: "/build/vendor/tf-2.0.0.es2017.min.js",
  wasmBackend: "/build/vendor/tf-backend-wasm-2.0.0.min.js",
  wasmBinary: "/build/vendor/tfjs-backend-wasm-2.0.0.wasm",
  blazeface: "/build/vendor/blazeface-0.0.7.min.js",
  model: "/build/vendor/blazeface/model.json"
};
